import type NavigatedFrom from '@alltrails/amplitude/enums/NavigatedFrom';
import type ShareSource from '@alltrails/amplitude/enums/ShareSource';
import type TrailPageType from '@alltrails/amplitude/enums/TrailPageType';
import logShareDisplayed from '@alltrails/amplitude/events/logShareDisplayed';
import type { ShareObject, ShareObjectType } from '../types/ShareObject';

const shareObjectTypeToShareSource: Partial<Record<ShareObjectType, ShareSource>> = {
  partner_collection: 'inspirational list',
  trip: 'trip planner'
};

export const getShareSource = (type: ShareObjectType): ShareSource => shareObjectTypeToShareSource[type] ?? (type as unknown as ShareSource);

type Args = {
  listType?: string;
  navigatedFrom?: NavigatedFrom;
  shareObject: ShareObject;
  trailPageType?: TrailPageType;
};

/**
 * Logs that a share surface was shown. Called from whichever surface the user actually got —
 * the native share sheet or the share modal — so the two paths stay comparable.
 */
export default function logShareDisplayedForObject({ listType, navigatedFrom, shareObject, trailPageType }: Args) {
  const source = getShareSource(shareObject.type);

  if (shareObject.type === 'partner_collection') {
    const pageSlug = shareObject.slug.replace('partner-collections/', '');
    logShareDisplayed({
      source,
      page_slug: pageSlug,
      trail_page_type: trailPageType,
      inspirational_list_type: listType,
      navigated_from: navigatedFrom
    });
    return;
  }

  logShareDisplayed({ id: String(shareObject.id), source, trail_page_type: trailPageType });
}
